import React, { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  InputLabel,
  TextField
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ModalActions } from '@/RestoreComponent/ModalActions';
import { LineItem } from '../Types';
import { falsey } from '@/common/utils/appointments';

type EditLineItemAmountProps = {
  open: boolean;
  handleClose: () => void;
  updateLineItemAmount: (row: LineItem, amount: number) => void;
  lineItem: LineItem | undefined;
};

const useStyles = makeStyles(() => {
  return {
    heading: {
      paddingBottom: 12,
      height: 98
    },
    errorHeading: {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderRightColor: 'transparent',
      borderTopColor: 'transparent',
      borderLeftColor: 'transparent'
    }
  };
});

export const EditLineItemAmount: React.FC<EditLineItemAmountProps> = ({
  open,
  handleClose,
  updateLineItemAmount,
  lineItem
}) => {
  const classes = useStyles();
  const [amount, setAmount] = useState(
    (lineItem?.refund_amount ?? 0).toFixed(2)
  );
  const [error, setError] = useState<string | undefined>(undefined);
  const handleSave = () => {
    if (lineItem) {
      updateLineItemAmount(lineItem, amount);
    }
    handleClose();
  };
  const validateAndSetAmount = (amount: number) => {
    const tenderedWithCredits =
      !falsey(lineItem?.credits_used) && lineItem?.credits_used !== 0;
    const itemPrice = tenderedWithCredits
      ? lineItem?.credits_used
      : lineItem?.final_amount;
    setAmount(amount);
    if (isNaN(amount)) {
      setAmount(0);
    } else if (amount <= 0) {
      setError('Amount must be positive');
    } else if (typeof itemPrice === 'number' && amount > itemPrice) {
      setError('Amount can not be greater than item price');
    } else if (tenderedWithCredits && amount % 1 !== 0) {
      setError('Number of credits to refund must be a whole number');
    } else {
      setError(undefined);
    }
  };
  const title = 'Edit Refund';

  return (
    <Dialog open={open} fullWidth maxWidth="xs" onClose={handleClose}>
      {error ? (
        <Alert severity="error" className={classes.errorHeading}>
          <AlertTitle>{title}</AlertTitle>
          {error}
        </Alert>
      ) : (
        <DialogTitle variant="h6" component="h2" className={classes.heading}>
          {title}
        </DialogTitle>
      )}
      <DialogContent>
        <Grid container mb={1} spacing={2}>
          <Grid item xs={6}>
            <InputLabel>Amount</InputLabel>
            <TextField
              fullWidth
              autoFocus
              inputProps={{ type: 'number' }}
              name="Amount"
              onChange={e => validateAndSetAmount(parseFloat(e.target.value))}
              value={amount}
            />
          </Grid>
          <Grid item xs={6} />
        </Grid>
      </DialogContent>
      <ModalActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={error !== undefined}
        >
          Save
        </Button>
      </ModalActions>
    </Dialog>
  );
};
